import DashboardHeaderContainer from "./DashboardHeaderContainer"   
import DashboardHeaderStore from "./DashboardHeaderStore"

export default DashboardHeaderStore(DashboardHeaderContainer);